import { cloudStorage } from '@tma.js/sdk-react'

/**
 * `CloudStorage` Telegram (Mini Apps 6.9+) — хранилище на стороне Telegram,
 * общее для всех устройств пользователя. Здесь живут **только** флаг
 * `onboarded` и отметки прочитанных новостей (CLAUDE.md, «Состояние»): ничего
 * о заказах, подарках и ваучерах, и никогда — код ваучера.
 *
 * Клиент бывает старым или не отвечает: чтение не ждёт дольше `timeoutMs` и
 * не бросает — нет ответа значит «значения нет»; запись — «выстрелил и забыл».
 */
export const readCloudItem = async (key: string, timeoutMs: number): Promise<string | null> => {
  if (!cloudStorage.getItem.isAvailable()) {
    return null
  }

  let timer: ReturnType<typeof setTimeout> | undefined

  try {
    const value = await Promise.race([
      cloudStorage.getItem(key),
      new Promise<null>((resolve) => {
        timer = setTimeout(() => resolve(null), timeoutMs)
      }),
    ])

    return value ? value : null
  } catch {
    return null
  } finally {
    clearTimeout(timer)
  }
}

export const writeCloudItem = (key: string, value: string): void => {
  if (!cloudStorage.setItem.isAvailable()) {
    return
  }

  cloudStorage.setItem(key, value).catch(() => {
    // Не сохранилось у Telegram — останется запись на устройстве.
  })
}
